export interface TermsServiceVersion {
  version: string;
  title: string;
  content: string;
  isLatest: boolean;
}

// TODO: 버전관리를 하게된다면 여기에 추가해서 버전관리를 할 수 있도록 할 것
export const termsServiceVersions: TermsServiceVersion[] = [
  {
    version: "2025.10.28",
    title: "서비스 이용약관",
    content: `제1조(목적)
빅브라운 주식회사(이하 '회사')은 제공하고자 하는 라라팡 서비스(이하 '서비스')를 이용하는 개인(이하 '이용자' 또는 '개인')의 정보(이하 '개인정보')를 보호하기 위해, 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 '정보통신망법') 등 관련 법령을 준수하고, 서비스 이용자의 개인정보 보호 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침(이하 '본 방침')을 수립합니다.

제2조(용어의 정의)
이 약관에서 사용하는 주요 용어의 정의는 다음과 같습니다.
1. "라라팡"라 함은 팬과 인플루언서 간의 만남을 중개하는 플랫폼 서비스를 말합니다.
2. "서비스"라 함은 구현되는 단말기(PC, Tablet, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 "이용자"가 이용할 수 있는 회사가 제공하는 제반 서비스를 의미합니다.
3. "이용자"란 이 약관에 따라 회사가 제공하는 서비스를 받는 "회원", "비회원"을 말합니다.

[이하 기존 내용...]`,
    isLatest: true,
  },
];

export const getLatestVersion = (): TermsServiceVersion => {
  return (
    termsServiceVersions.find((version) => version.isLatest) ||
    termsServiceVersions[0]
  );
};
